import { createAction, props } from "@ngrx/store";

// Generate Report Actions
export const getReportsList = createAction(
  "[Reports] Get All Reports List Action"
);
export const loadReportsList = createAction(
  "[Reports] Load All Reports List Action",
  props<{ response: any[] }>()
);
export const generateReport = createAction(
  "[Reports] Generate Report Action",
  props<{ report: any; options: any }>()
);
export const loadGeneratedReport = createAction(
  "[Reports] Load Generated Report Action",
  props<{ response: any }>()
);

// Report Status Table List Actions
export const resetReportState = createAction(
  "[Reports] Reset Reports State Action"
);
export const getReportStatusList = createAction(
  "[Reports] Get All Reports Status List Action",
  props<{ options: any }>()
);
export const loadReportStatusList = createAction(
  "[Reports] Load All Reports Status List Action",
  props<{ response: any[] }>()
);
export const getReportStatusExcelList = createAction(
  "[Reports] Get All Reports Status Excel List Action",
  props<{ options: any }>()
);
export const loadReportStatusExcelList = createAction(
  "[Reports] Load All Reports Status Excel List Action",
  props<{ response: any[] }>()
);
export const getReportData = createAction(
  "[Reports] Get Report Data Action",
  props<{ code: string }>()
);
export const loadReportData = createAction(
  "[Reports] Load Report Data Action",
  props<{ response: any }>()
);

// Table Configuration Settings
export const getReportStatusTableConfig = createAction(
  "[Reports] Get Report Status Table Configuration Action",
  props<{ options: any }>()
);
export const loadReportStatusTableConfig = createAction(
  "[Reports] Load Reports Status Table Configuration Action",
  props<{ response: any[] }>()
);
export const saveReportStatusTableConfig = createAction(
  "[Reports] Save Reports Status Table Configuration Action",
  props<{ config: any }>()
);

export const setLoadingEndState = createAction("[Reports] Load End Action");
